import { __assign } from "tslib";
// DS: i6.20
import React from 'react';
import IconWrap from '../../IconWrap';
var AddImage = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M21 3a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h18zm-1 2H4v10.27l1.879-1.877a1 1 0 011.32-.083l.094.083 2.78 2.781-2.674 2.825h2.753l6.883-7.271.092-.086a.993.993 0 01.237-.145.998.998 0 01.823.35L20 13.97V19l-7.103-.002.001.002H20V5zm-8.5 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3z", fillRule: "evenodd" }))));
};
AddImage.displayName = 'AddImage';
export default AddImage;
//# sourceMappingURL=AddImage.js.map